import Vue from 'vue'

import PortalVue from 'portal-vue'
import Notifications from 'vue-notification'

Vue.use(Notifications)

Vue.use(PortalVue)
